module.exports = __webpack_public_path__ + "img/ic_store_trait_top_img5.912dfc9c.png";